// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "-" + {"27":"67221c2d","348":"2f9e2012","571":"cccb6c25","924":"e3bcf7d7"}[chunkId] + ".chunk.js";
};